import { render, staticRenderFns } from "./0020.vue?vue&type=template&id=146276fc&scoped=true&"
import script from "./0020.vue?vue&type=script&lang=js&"
export * from "./0020.vue?vue&type=script&lang=js&"
import style0 from "./0020.vue?vue&type=style&index=0&id=146276fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146276fc",
  null
  
)

export default component.exports